import { formatMoney } from '@c214/shared';
import type { ReactNode } from 'react';
import { Button } from '../ui/button';
import { QuantityStepper } from '../ui/quantity-stepper';

interface Props {
  name: string;
  spec: string;
  total: number;
  qty: number;
  onQtyChange: (next: number) => void;
  onAdd: () => void;
  heart: ReactNode;
}

export function StickyBuyBar({ name, spec, total, qty, onQtyChange, onAdd, heart }: Props) {
  return (
    <div className="sticky bottom-0 z-[15] flex flex-wrap items-center gap-4 border-t border-line bg-bg/[0.92] px-[clamp(24px,5vw,72px)] py-4 backdrop-blur-[8px]">
      <div className="min-w-40 flex-1">
        <p className="text-[15px] font-bold text-ink">{name}</p>
        <p className="mono-label mt-[2px] text-[10px]">{spec}</p>
      </div>
      <span className="text-[24px] font-extrabold text-ink">{formatMoney(total)}</span>
      <QuantityStepper value={qty} onChange={onQtyChange} min={1} />
      {heart}
      <Button variant="accent" size="lg" onClick={onAdd}>
        ДОДАТИ В КОШИК
      </Button>
    </div>
  );
}
